export default __webpack_public_path__ + "static/media/vEghtesad-removebg-preview.3152aebb.png";